@use "variables" as *;

.mainDiv {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.container {
  padding: $spacing-s calc(#{$spacing-s} + #{$spacing-m}) !important;
  display: flex !important;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.collapse {
  width: 100%;
}

.title {
  font-size: $fontSize-m;
  font-weight: normal;
  padding-top: 6px;
  padding-bottom: 6px;
  align-self: center;
}

.loadingDiv {
  padding-top: $spacing-s;
  padding-left: $spacing-m;
}

.notice {
  font-size: $fontSize-xs;
  margin-bottom: $spacing-m;
}

.addButton {
  position: absolute;
  height: auto !important;
  top: 0;
  right: $spacing-m;
}

.badge {
  align-self: center;
  justify-self: center;
  padding-left: $spacing-l;
}
